'use client';

import React from 'react';
import Tooltip from '@/components/common/Tooltip';

interface Publication {
  platformName: string;
  iconUrl: string;
  status: 'published' | 'in_progress' | 'pending' | 'failed';
  externalUrl?: string;
  errorMessage?: string;
}

interface PublicationStatusProps {
  publications: Publication[];
}

const statusStyles = {
  published: 'filter-none',
  in_progress: 'filter grayscale animate-pulse',
  pending: 'filter grayscale',
  failed: 'filter grayscale-0 border-2 border-red-500 rounded-full',
};

export default function PublicationStatus({ publications }: PublicationStatusProps) {
  if (!publications || publications.length === 0) {
    return (
      <span className="text-xs text-gray-500 italic">
        Not yet published to any external platforms.
      </span>
    );
  }

  return (
    <div className="flex items-center space-x-2">
      {publications.map((pub, index) => {
        const tooltipContent = (
          <div>
            <p className="font-semibold">{pub.platformName}</p>
            <p>Status: <span className="capitalize">{pub.status.replace('_', ' ')}</span></p>
            {pub.status === 'failed' && <p className="text-red-300">Error: {pub.errorMessage}</p>}
          </div>
        );

        const icon = (
          <img 
            src={pub.iconUrl}
            alt={pub.platformName}
            className={`w-5 h-5 ${statusStyles[pub.status]}`}
          />
        );

        return (
          <Tooltip key={index} content={tooltipContent} position="top">
            {pub.externalUrl ? (
              <a href={pub.externalUrl} target="_blank" rel="noopener noreferrer">
                {icon}
              </a>
            ) : (
              <span>{icon}</span>
            )}
          </Tooltip>
        );
      })}
    </div>
  );
}
